// Skip links

export default class SkipLink {
    constructor() {
        this.ui = this.getUI();
        this.listen();
    }

    getUI() {
        return {
            skiplink: document.querySelectorAll(".skiplink__item"),
            body: document.querySelector("body")
        }
    }

    listen() {
        this.ui.skiplink.forEach((item) => {
            item.addEventListener("keyup",() => {
                if(window.scrollY > 0) { // Pour revenir au top de la page lorsque le focus se trouve sur un des skiplink
                    window.scroll(0, 0);
                }
            });
        });
    }
}